<template>
  <div class="client-modules">
    <a-modal :title="title"
             v-model="visible"
             @ok="handleOk"
             :width="700">
      <div class="client-information">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 16 }"
                @submit="handleSubmit">
          <a-form-item label="客户名称">
            <a-input placeholder="请输入客户名称"
                     v-decorator="['name', { rules: [{ required: true, message: '请输入客户名称' }] }]" />
          </a-form-item>
          <a-form-item label="客户类别">
            <a-radio-group name="radioGroup"
                           :defaultValue="1"
                           @change="changeMenuType">
              <a-radio :value="1">VIP客户</a-radio>
              <a-radio :value="2">优质会员</a-radio>
              <a-radio :value="3">普通用户</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="联系电话">
            <a-input placeholder="请输入联系电话"
                     v-decorator="['phone', { rules: [{ required: true, message: '请输入联系电话' }] }]" />
          </a-form-item>
          <a-form-item label="所在区域">
            <a-select labelInValue
                      style="width: 132px"
                      placeholder="选择省"
                      @change="ChangeProvince">
              <a-icon slot="suffixIcon"
                      type="caret-down"
                      style="color: #555555" />
              <a-select-option value="jack"
                               v-for="(item, index) in provinceList"
                               :key="index"></a-select-option>
            </a-select>
            <a-select labelInValue
                      style="width: 132px;margin:0 19px"
                      placeholder="选择市"
                      @change="ChangeCity">
              <a-icon slot="suffixIcon"
                      type="caret-down"
                      style="color: #555555" />
              <a-select-option value="jack"
                               v-for="(item, index) in cityList"
                               :key="index"></a-select-option>
            </a-select>
            <a-select labelInValue
                      style="width: 132px"
                      placeholder="选择区/县"
                      @change="ChangeDistrict">
              <a-icon slot="suffixIcon"
                      type="caret-down"
                      style="color: #555555" />
              <a-select-option value="jack"
                               v-for="(item, index) in districtList"
                               :key="index"></a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="详细地址">
            <a-input placeholder="请输入详细地址"
                     v-decorator="['location']" />
          </a-form-item>
          <a-form-item label="备注信息">
            <a-input placeholder="请输入备注信息"
                     v-decorator="['remark']" />
          </a-form-item>
          <a-form-item label="销售员">
            <a-select labelInValue
                      style="width: 200px"
                      placeholder="选择省"
                      @change="ChangeSalesman">
              <a-icon slot="suffixIcon"
                      type="caret-down"
                      style="color: #555555" />
              <a-select-option value="jack"
                               v-for="(item, index) in salesmanList"
                               :key="index"></a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: '新增客户',
      visible: false,
      provinceList: [],       // 省份列表
      cityList: [],                // 选择市
      districtList: [],          // 选择区/县
      salesmanList:[],       // 销售员
      form: this.$form.createForm(this)
    }
  },
  methods: {
    add () {
      this.title = '新增客户'
      this.visible = true
    },
    edit (data) {
      this.title = '编辑客户'
      this.visible = true
    },
    handleOk () { },
    // 选择客户类型
    changeMenuType () { },
    // 选择省
    ChangeProvince () { },
    // 选择城市
    ChangeCity () { },
    // 选择区/县
    ChangeDistrict () { },
    // 选择销售员
    ChangeSalesman() {},
    // 提交
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = {}
          formData.title = values.title
        }
      })
    }
  }
}
</script>
<style lang="scss">
.client-modules {
  .client-information {
  }
}
</style>